<template>
    <button :type="props.buttonType" @click="onClick" :class="props.className" :disabled="enableNext">
        <slot />
    </button>
</template>

<script setup>
import { ref } from 'vue';

// Define props 
const props = defineProps({
    className: {
        type: String,
        default: 'app-btn-primary'
    },
    buttonType: {
        type: String,
        default: 'submit'
    },
});

// defineEmits
const emit = defineEmits(['click']);

// Reactive state 
const enableNext = ref(false);

// Methods
const onClick = async () => {
    if (enableNext.value) {
        return false;
    }
    enableNext.value = true;
    
    // Emit the custom click event
    await emit('click');
    
    setTimeout(() => {
        enableNext.value = false;
    }, 500);
};
</script>


<style scoped lang="scss">
button[disabled=disabled] {
    cursor: auto !important;
}
</style>